import SidebarOptionsCard from "./components/cards/SidebarOptionsCard.vue";
import ReportErrorIconButton from "./components/buttons/ReportErrorIconButton/ReportErrorIconButton.vue";
import Input from "./components/forms/Input.vue";

export default (app: any) => {
  app.component("SidebarOptionsCard", SidebarOptionsCard);
  app.component("ReportErrorIconButton", ReportErrorIconButton);
  app.component("Input", Input);
};
